import { render, staticRenderFns } from "./beidouApiConfig.vue?vue&type=template&id=09acb35d&scoped=true&"
import script from "./beidouApiConfig.vue?vue&type=script&lang=js&"
export * from "./beidouApiConfig.vue?vue&type=script&lang=js&"
import style0 from "./beidouApiConfig.vue?vue&type=style&index=0&id=09acb35d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09acb35d",
  null
  
)

export default component.exports